import { translate } from 'App/Internationalization';
import React from 'react';
import AgentCard from '../shared/AgentCard';

/**
 * @param {{
 *  history?: import('history').History,
 *  location?: import('history').Location,
 *  match?: { params?: { propertyId?: string } }
 * }} props
 * @returns {JSX.Element}
 */
export default function PropertyTeam(props) {
	void props;

	return (
		<section className="app-block-list">
			<h1 className="hl-ms-6 mt-10 mb-6">
				{translate('homeowner.pages.properties.scoped.submenu.team')}
			</h1>
			<AgentCard />
		</section>
	);
}
